export const SupportingExtensions = ['pdf', 'csv', 'xlsx', 'docx', 'png', 'jpg', 'jpeg', 'gif'] as const
export const SupportingMimeTypes = [
  'application/pdf',
  // 'text/csv',
  // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/png',
  'image/jpg',
  'image/jpeg',
  // 'image/gif',
] as const

export const SupportingMimeTypeToFileExtension: Record<
  (typeof SupportingMimeTypes)[number],
  (typeof SupportingExtensions)[number]
> = {
  'application/pdf': 'pdf',
  // 'text/csv': 'csv',
  // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  // 'image/gif': 'gif',
} as const
